// extracted by mini-css-extract-plugin
module.exports = {"widget":"_9a28a6d"};